import { useState, useEffect } from 'react';

interface AdminHeaderProps {
  title: string;
  subtitle?: string;
}

function getWeatherIcon(hour: number): { icon: string; label: string } {
  if (hour >= 6 && hour < 9) return { icon: 'ri-sun-foggy-line', label: 'בוקר' };
  if (hour >= 9 && hour < 16) return { icon: 'ri-sun-line', label: 'שמשי' };
  if (hour >= 16 && hour < 19) return { icon: 'ri-sun-cloudy-line', label: 'אחה"צ' };
  if (hour >= 19 && hour < 21) return { icon: 'ri-moon-cloudy-line', label: 'ערב' };
  return { icon: 'ri-moon-line', label: 'לילה' };
}

const DAY_NAMES = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
const MONTH_NAMES = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];

export default function AdminHeader({ title, subtitle }: AdminHeaderProps) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const dayName = DAY_NAMES[now.getDay()];
  const day = now.getDate();
  const month = MONTH_NAMES[now.getMonth()];
  const year = now.getFullYear();
  const weather = getWeatherIcon(hours);
  const timeStr = `${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;

  return (
    <header
      className="h-16 bg-white border-b-2 border-rose-100 flex items-center justify-between px-6 sticky top-0 z-10"
      dir="rtl"
    >
      {/* Title */}
      <div>
        <h1 className="text-base font-bold text-gray-800" style={{ fontFamily: "'Heebo', sans-serif" }}>
          {title}
        </h1>
        {subtitle && <p className="text-xs text-gray-400">{subtitle}</p>}
      </div>

      {/* Date / Time / Weather widget */}
      <div className="flex items-center gap-2">
        {/* Weather icon */}
        <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border-2 border-amber-100 rounded-xl">
          <div className="w-5 h-5 flex items-center justify-center text-amber-400">
            <i className={`${weather.icon} text-base`}></i>
          </div>
          <span className="text-xs font-semibold text-amber-500 hidden sm:block">{weather.label}</span>
        </div>

        {/* Clock */}
        <div className="flex items-center gap-2 px-3 py-2 bg-rose-50 border-2 border-rose-100 rounded-xl">
          <div className="w-4 h-4 flex items-center justify-center text-rose-400">
            <i className="ri-time-line text-sm"></i>
          </div>
          <span className="text-xs font-bold text-gray-700 tabular-nums" dir="ltr">{timeStr}</span>
        </div>

        {/* Date */}
        <div className="hidden md:flex items-center gap-2 px-3 py-2 bg-white border-2 border-rose-100 rounded-xl">
          <div className="w-4 h-4 flex items-center justify-center text-rose-400">
            <i className="ri-calendar-line text-sm"></i>
          </div>
          <span className="text-xs font-semibold text-gray-600 whitespace-nowrap">
            יום {dayName}, {day} {month} {year}
          </span>
        </div>
      </div>
    </header>
  );
}
